


import React, { useRef, useEffect, useState, ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Layout from '../../components/Layout/AdminLayout/AdminLayout';

import { RequestCreateAdmin, CreateUpdateAdminError } from '../../interface/IAdminRegistry';
import adminRegistryService from './adminRegistryService';
import helpers from '../../helpers/index';

import CreateAdminSuccessModal from '../../components/Modal/CreateAdminSuccessModal';


import iconVisible from '../../assets/visible.png';
import iconHide from '../../assets/hide.png';



function CreateAdmin() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState('');
    const [requestCreateAdmin, setRequestCreateAdmin] = useState<RequestCreateAdmin>({
        permission: 'Read Only'
    });
    const [selectedOption, setSelectedOption] = useState("Read Only");
    const [createUpdateAdminError, setCreateUpdateAdminError] = useState<CreateUpdateAdminError>({});
    const [confirmPassword, setConfirmPassword] = useState('');

    const [isModalOpen, setModalOpen] = useState(false);
    const [isReadOnly, setIsReadOnly] = useState(false);

    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);

    function CancelButtonClick() {
        navigate('/Admin/AdminRegistry');
    }

    function getPermission() {

        var permission = helpers.getPermission();
        setIsReadOnly(permission == "ReadOnly");
    }

    async function SaveButtonClick() {
        try {


            document.querySelector('.loader-container')?.classList.add('loader');
            if (!HasRequirementError()) {



                const requestCreateAdminPayload: RequestCreateAdmin = {
                    username: requestCreateAdmin?.username,
                    password: requestCreateAdmin?.password,
                    firstname: requestCreateAdmin?.firstname,
                    lastname: requestCreateAdmin?.lastname,
                    middlename: requestCreateAdmin?.middlename,
                    email: requestCreateAdmin?.email,
                    permission: requestCreateAdmin?.permission
                };

                await adminRegistryService.createAdminRegistry(requestCreateAdminPayload);

                openModal();

            }

        }
        catch (error) {
            setErrorMessage(String(error));

        }
        finally {

            document.querySelector('.loader-container')?.classList.remove('loader');
        }
    }


    const openModal = () => {
        setModalOpen(true);
    };

    const onStayModal = () => {
        setModalOpen(false);
        navigate('/Admin/AdminRegistry');
    };

    const onLoginModal = () => {
        setModalOpen(false);
        window.location.href = "/Admin/Login";
    }



    function HasRequirementError(): boolean {

        var createUpdateAdminErrorVal: CreateUpdateAdminError = {};

        const errMessage = "This parameter is required for creating an account";

        if (!requestCreateAdmin?.firstname) {
            console.log('HasRequirementError triggered firstnameRef');
            createUpdateAdminErrorVal.firstnameError = errMessage;
        }

        if (!requestCreateAdmin?.lastname) {
            createUpdateAdminErrorVal.lastnameError = errMessage;
        }

        if (!requestCreateAdmin?.username) {
            createUpdateAdminErrorVal.usernameError = errMessage;
        }

        if (!requestCreateAdmin?.email) {
            createUpdateAdminErrorVal.emailError = errMessage;
        }

        if (!requestCreateAdmin?.password) {
            createUpdateAdminErrorVal.passwordError = errMessage;
        }

        if ((!confirmPassword) || requestCreateAdmin?.password !== confirmPassword) {
            createUpdateAdminErrorVal.confirmPasswordError = "Password did not match.";
        }


        if (Object.values(createUpdateAdminErrorVal).some(error => error)) {

            setCreateUpdateAdminError(createUpdateAdminErrorVal);

            return true;
        }
        else {
            return false;
        }
    }

    function passwordToggleClick() {
        setIsPasswordVisible(!isPasswordVisible);
    }

    function confirmPasswordToggleClick() {
        setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
    }


    useEffect(() => {
        (async () => {

            document.querySelector('.loader-container')?.classList.add('loader');

            await getPermission();

            document.querySelector('.loader-container')?.classList.remove('loader');
        })();
    }, []);


    return (


        <Layout>

            <div>

                <CreateAdminSuccessModal isOpen={isModalOpen} onClose={onStayModal} onClose2={onLoginModal} />
            </div>

            <div className="title-container">
                <div className="dv-title">

                    <h1>Admin Registry</h1>

                </div>
                <div className="title-btn-container vertical-flex-bottom">

                    <button type="button" id="btnCancel" disabled={isReadOnly}
                        onClick={CancelButtonClick}
                        className="btn-white-green-2 center-middle">Cancel</button>
                    &nbsp;
                    <button type="button" id="btnSave" disabled={isReadOnly}
                        onClick={SaveButtonClick}
                        className="btn-green-2 center-middle">Save</button>

                </div>
            </div>
            <br />
            <div className='content-container'>
                <div className='padding-container'>
                    <div className='title'>
                        Admin Info
                    </div>

                    <div>

                        <div className='label-1'>
                            First name:
                        </div>
                        <div>
                            <input disabled={isReadOnly} type="text" className={createUpdateAdminError?.firstnameError ? "textbox-red-2" : "textbox-green-2"} name="firstname" id="txtFirstname" placeholder="Enter First Name"
                                value={requestCreateAdmin?.firstname}
                                onChange={(event) =>
                                    setRequestCreateAdmin((prevState) => ({
                                        ...prevState,
                                        firstname: event.target.value,
                                    }))
                                } />

                        </div>
                        <div>
                            <label className='label-error-1'>{createUpdateAdminError?.firstnameError} </label>
                        </div>
                    </div>
                    <div>

                        <div className='label-1'>
                            Middle name:
                        </div>
                        <div>
                            <input disabled={isReadOnly} type="text" className="textbox-green-2" name="middlename" id="txtMiddlename" placeholder="Enter Middle Name"
                                value={requestCreateAdmin?.middlename}
                                onChange={(event) =>
                                    setRequestCreateAdmin((prevState) => ({
                                        ...prevState,
                                        middlename: event.target.value,
                                    }))
                                } />

                        </div>
                        <div>
                            <label className='label-error-1'> </label>
                        </div>
                    </div>
                    <div>

                        <div className='label-1'>
                            Last name:
                        </div>
                        <div>
                            <input disabled={isReadOnly} type="text" className={createUpdateAdminError?.lastnameError ? "textbox-red-2" : "textbox-green-2"} name="lastname" id="txtLastname" placeholder="Enter Last Name"
                                value={requestCreateAdmin?.lastname}
                                onChange={(event) =>
                                    setRequestCreateAdmin((prevState) => ({
                                        ...prevState,
                                        lastname: event.target.value,
                                    }))
                                } />

                        </div>
                        <div>
                            <label className='label-error-1'>{createUpdateAdminError?.lastnameError} </label>
                        </div>
                    </div>
                    <div>

                        <div className='label-1'>
                            Username
                        </div>
                        <div>
                            <input disabled={isReadOnly} type="text" className={createUpdateAdminError?.usernameError ? "textbox-red-2" : "textbox-green-2"} name="username" id="txtUsername" placeholder="Enter Username"
                                value={requestCreateAdmin?.username}
                                onChange={(event) =>
                                    setRequestCreateAdmin((prevState) => ({
                                        ...prevState,
                                        username: event.target.value,
                                    }))
                                } />

                        </div>
                        <div>
                            <label className='label-error-1'>{createUpdateAdminError?.usernameError} </label>
                        </div>
                    </div>
                    <div>

                        <div className='label-1'>
                            Email
                        </div>
                        <div>
                            <input disabled={isReadOnly} type="text" className={createUpdateAdminError?.emailError ? "textbox-red-2" : "textbox-green-2"} name="email" id="txtEmail" placeholder="eg. koopmember@koop.com"
                                value={requestCreateAdmin?.email}
                                onChange={(event) =>
                                    setRequestCreateAdmin((prevState) => ({
                                        ...prevState,
                                        email: event.target.value,
                                    }))
                                } />

                        </div>
                        <div>
                            <label className='label-error-1'> {createUpdateAdminError?.emailError}</label>
                        </div>
                    </div>
                    <div>

                        <div className='label-1'>
                            Password
                        </div>
                        <div>
                            <div>
                                <div className="icon-container">
                                    <input disabled={isReadOnly}
                                        type={(isPasswordVisible) ? "text" : "password"}
                                        className={createUpdateAdminError?.passwordError ? "textbox-red-2" : "textbox-green-2"} name="password" id="txtPassword" placeholder="Enter your Password"
                                        value={requestCreateAdmin?.password}
                                        onChange={(event) =>
                                            setRequestCreateAdmin((prevState) => ({
                                                ...prevState,
                                                password: event.target.value,
                                            }))
                                        } />

                                    {(!isPasswordVisible) ? <span className="toggle-password" onClick={passwordToggleClick}><img src={iconVisible} className="responsive-image" /></span> : ""}
                                    {(isPasswordVisible) ? <span className="toggle-password" onClick={passwordToggleClick}><img src={iconHide} className="responsive-image" /></span> : ""}
                                </div>
                            </div>
                        </div>
                        <div>
                            <label className='label-error-1'> {createUpdateAdminError?.passwordError}</label>
                        </div>
                    </div>
                    <div>

                        <div className='label-1'>
                            Confirm Password
                        </div>
                        <div>
                            <div>
                                <div className="icon-container">
                                    <input disabled={isReadOnly}
                                        type={(isConfirmPasswordVisible) ? "text" : "password"}
                                        className={createUpdateAdminError?.confirmPasswordError ? "textbox-red-2" : "textbox-green-2"} name="confirmPassword" id="txtConfirmPassword" placeholder="Re-type your Password"
                                        value={confirmPassword}
                                        onChange={(event) =>
                                            setConfirmPassword(event.target.value)
                                        } />
                                    {(!isConfirmPasswordVisible) ? <span className="toggle-password" onClick={confirmPasswordToggleClick}><img src={iconVisible} className="responsive-image" /></span> : ""}
                                    {(isConfirmPasswordVisible) ? <span className="toggle-password" onClick={confirmPasswordToggleClick}><img src={iconHide} className="responsive-image" /></span> : ""}
                                </div>
                            </div>
                        </div>
                        <div>
                            <label className='label-error-1'>{createUpdateAdminError?.confirmPasswordError} </label>
                        </div>
                    </div>
                    <div>
                        <div className="title">
                            Permission
                        </div>
                        <div className='label-1'>
                            Please select a permission type
                        </div>
                        <div>
                            <div className='content-container-4'>
                                <div>
                                    <label>
                                        <input disabled={isReadOnly} type="radio" name="permission" value="ReadOnly"
                                            checked={requestCreateAdmin?.permission === "ReadOnly"}
                                            onChange={(e) =>
                                                setRequestCreateAdmin({
                                                    ...requestCreateAdmin,
                                                    permission: e.target.value,
                                                })
                                            }
                                        /> Read Only

                                    </label>
                                </div>
                                <div>

                                    <label>
                                        <input disabled={isReadOnly} type="radio" name="permission" value="ReadAndWrite"
                                            checked={requestCreateAdmin?.permission === "ReadAndWrite"}
                                            onChange={(e) =>
                                                setRequestCreateAdmin({
                                                    ...requestCreateAdmin,
                                                    permission: e.target.value,
                                                })
                                            }
                                        /> Read and Write
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </Layout>
    );
}


export default CreateAdmin;